//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

const URL = import.meta.env.VITE_TELEMATIC_MILEAGE_API || `${window.location.origin}/mileage`;

export class TelematicsMileageClient {
	protected instance: AxiosInstance;
	protected baseUrl: string;
	protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

	constructor(baseUrl?: string, instance?: AxiosInstance) {
		this.instance = instance || axios.create();

		this.baseUrl = baseUrl ?? URL;
	}

	/**
	 * Checks if a policy exists in the database and belongs to the authenticated customer.
	 * @param policyReference (optional) The unique policy reference number to check (e.g., HAVPC00000001).
	 * @return Successfully checked policy existence. Returns true if policy exists and belongs to customer.
	 */
	exists(policyReference: string | undefined, cancelToken?: CancelToken): Promise<PolicyExistsDto> {
		let url_ = this.baseUrl + '/api/v1/Mileage/policy/exists?';
		if (policyReference === null) throw new globalThis.Error("The parameter 'policyReference' cannot be null.");
		else if (policyReference !== undefined) url_ += 'policyReference=' + encodeURIComponent('' + policyReference) + '&';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processExists(_response);
			});
	}

	protected processExists(response: AxiosResponse): Promise<PolicyExistsDto> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<PolicyExistsDto>(result200);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException(
				'The policy reference is missing, empty, or in an invalid format.',
				status,
				_responseText,
				_headers,
				result400,
			);
		} else if (status === 401) {
			const _responseText = response.data;
			let result401: any = null;
			let resultData401 = _responseText;
			result401 = resultData401;
			return throwException(
				'The JWT token is missing or does not contain a valid customer reference claim.',
				status,
				_responseText,
				_headers,
				result401,
			);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<PolicyExistsDto>(null as any);
	}

	/**
	 * Retrieves the mileage summary for a specific policy, showing annual allowance, usage, and remaining balance.
	 * @param policyReference (optional) The unique policy reference number (e.g., HAVPC00000001). Must belong to the authenticated customer.
	 * @return Successfully retrieved the mileage summary for the policy.
	 */
	summary(policyReference: string | undefined, cancelToken?: CancelToken): Promise<MileageSummaryDto> {
		let url_ = this.baseUrl + '/api/v1/Mileage/summary?';
		if (policyReference === null) throw new globalThis.Error("The parameter 'policyReference' cannot be null.");
		else if (policyReference !== undefined) url_ += 'policyReference=' + encodeURIComponent('' + policyReference) + '&';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processSummary(_response);
			});
	}

	protected processSummary(response: AxiosResponse): Promise<MileageSummaryDto> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<MileageSummaryDto>(result200);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException(
				'The policy reference is missing, empty, or in an invalid format.',
				status,
				_responseText,
				_headers,
				result400,
			);
		} else if (status === 401) {
			const _responseText = response.data;
			let result401: any = null;
			let resultData401 = _responseText;
			result401 = resultData401;
			return throwException(
				'The JWT token is missing or does not contain a valid customer reference claim.',
				status,
				_responseText,
				_headers,
				result401,
			);
		} else if (status === 404) {
			const _responseText = response.data;
			let result404: any = null;
			let resultData404 = _responseText;
			result404 = resultData404;
			return throwException(
				'The policy was not found or does not belong to the authenticated customer.',
				status,
				_responseText,
				_headers,
				result404,
			);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<MileageSummaryDto>(null as any);
	}

	/**
	 * Retrieves daily mileage history data for graphing and trend analysis over a specified time period.
	 * @param policyReference (optional) The unique policy reference number (e.g., HAVPC00000001). Must belong to the authenticated customer.
	 * @param period (optional) The time period for the history: `weekly` (7 days) or `monthly` (30 days). Defaults to `weekly`.
	 * @return Successfully retrieved the mileage history with daily data points.
	 */
	history(
		policyReference: string | undefined,
		period: string | undefined,
		cancelToken?: CancelToken,
	): Promise<MileageHistoryDto> {
		let url_ = this.baseUrl + '/api/v1/Mileage/history?';
		if (policyReference === null) throw new globalThis.Error("The parameter 'policyReference' cannot be null.");
		else if (policyReference !== undefined) url_ += 'policyReference=' + encodeURIComponent('' + policyReference) + '&';
		if (period === null) throw new globalThis.Error("The parameter 'period' cannot be null.");
		else if (period !== undefined) url_ += 'period=' + encodeURIComponent('' + period) + '&';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processHistory(_response);
			});
	}

	protected processHistory(response: AxiosResponse): Promise<MileageHistoryDto> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<MileageHistoryDto>(result200);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException(
				"The policy reference is invalid or the period value is not \'weekly\' or \'monthly\'.",
				status,
				_responseText,
				_headers,
				result400,
			);
		} else if (status === 401) {
			const _responseText = response.data;
			let result401: any = null;
			let resultData401 = _responseText;
			result401 = resultData401;
			return throwException(
				'The JWT token is missing or does not contain a valid customer reference claim.',
				status,
				_responseText,
				_headers,
				result401,
			);
		} else if (status === 404) {
			const _responseText = response.data;
			let result404: any = null;
			let resultData404 = _responseText;
			result404 = resultData404;
			return throwException(
				'The policy was not found or does not belong to the authenticated customer.',
				status,
				_responseText,
				_headers,
				result404,
			);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<MileageHistoryDto>(null as any);
	}

	/**
	 * Calculates the price for increasing the annual mileage allowance on a policy via Mid-Term Adjustment (MTA).
	 * @param body (optional) The mileage top-up command containing policy reference, requested annual mileage, and optional transaction ID.
	 * @return Successfully rated the mileage top-up. Returns pricing and transaction details.
	 */
	rate(body: RateTopUpMilesCommand | undefined, cancelToken?: CancelToken): Promise<RateTopUpMilesResponse> {
		let url_ = this.baseUrl + '/api/v1/Mileage/topup/rate';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = JSON.stringify(body);

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'POST',
			url: url_,
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processRate(_response);
			});
	}

	protected processRate(response: AxiosResponse): Promise<RateTopUpMilesResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<RateTopUpMilesResponse>(result200);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException(
				'The requested mileage is invalid, less than or equal to current mileage, or other validation failed.',
				status,
				_responseText,
				_headers,
				result400,
			);
		} else if (status === 401) {
			const _responseText = response.data;
			let result401: any = null;
			let resultData401 = _responseText;
			result401 = resultData401;
			return throwException(
				'The JWT token is missing or does not contain a valid customer reference claim.',
				status,
				_responseText,
				_headers,
				result401,
			);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<RateTopUpMilesResponse>(null as any);
	}

	/**
	 * Cancels a pending mileage top-up Mid-Term Adjustment (MTA) transaction.
	 * @param body (optional) The cancel command containing the policy reference and transaction ID to cancel.
	 * @return The MTA transaction was successfully cancelled.
	 */
	cancel(body: CancelTopUpMilesCommand | undefined, cancelToken?: CancelToken): Promise<void> {
		let url_ = this.baseUrl + '/api/v1/Mileage/topup/cancel';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = JSON.stringify(body);

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'POST',
			url: url_,
			headers: {
				'Content-Type': 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processCancel(_response);
			});
	}

	protected processCancel(response: AxiosResponse): Promise<void> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 204) {
			return Promise.resolve<void>(null as any);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException(
				'The request is invalid - missing or malformed policy reference or transaction ID.',
				status,
				_responseText,
				_headers,
				result400,
			);
		} else if (status === 401) {
			const _responseText = response.data;
			let result401: any = null;
			let resultData401 = _responseText;
			result401 = resultData401;
			return throwException(
				'The JWT token is missing or does not contain a valid customer reference claim.',
				status,
				_responseText,
				_headers,
				result401,
			);
		} else if (status === 404) {
			const _responseText = response.data;
			let result404: any = null;
			let resultData404 = _responseText;
			result404 = resultData404;
			return throwException(
				'The specified transaction was not found or has already been processed.',
				status,
				_responseText,
				_headers,
				result404,
			);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<void>(null as any);
	}

	/**
	 * Prepares a payment intent with the payment gateway for processing a new card payment.
	 * @param body (optional) The payment intent command containing payment amount, cardholder details, and billing address.
	 * @return Successfully created the payment intent. Use the returned identifiers with the payment SDK.
	 */
	intent(body: MakePaymentIntentCommand | undefined, cancelToken?: CancelToken): Promise<MakePaymentIntentResponse> {
		let url_ = this.baseUrl + '/api/v1/Payment/intent';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = JSON.stringify(body);

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'POST',
			url: url_,
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processIntent(_response);
			});
	}

	protected processIntent(response: AxiosResponse): Promise<MakePaymentIntentResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<MakePaymentIntentResponse>(result200);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException(
				'Required fields are missing or validation failed (e.g., invalid email, unsupported currency).',
				status,
				_responseText,
				_headers,
				result400,
			);
		} else if (status === 401) {
			const _responseText = response.data;
			let result401: any = null;
			let resultData401 = _responseText;
			result401 = resultData401;
			return throwException(
				'The JWT token is missing or does not contain a valid customer reference claim.',
				status,
				_responseText,
				_headers,
				result401,
			);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<MakePaymentIntentResponse>(null as any);
	}

	/**
	 * Authorizes payment and completes a Mid-Term Adjustment (MTA) transaction to apply policy changes.
	 * @param body (optional) The take-up command containing policy reference, MTA transaction ID, take-up details, and payment credentials.
	 * @return Successfully authorized payment and completed the MTA. The policy has been updated.
	 */
	takeup(body: TakeUpCommand | undefined, cancelToken?: CancelToken): Promise<TakeUpResponse> {
		let url_ = this.baseUrl + '/api/v1/Payment/takeup';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = JSON.stringify(body);

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'POST',
			url: url_,
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processTakeup(_response);
			});
	}

	protected processTakeup(response: AxiosResponse): Promise<TakeUpResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<TakeUpResponse>(result200);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException(
				'Validation failed, invalid payment method combination, or MTA take-up rejected.',
				status,
				_responseText,
				_headers,
				result400,
			);
		} else if (status === 401) {
			const _responseText = response.data;
			let result401: any = null;
			let resultData401 = _responseText;
			result401 = resultData401;
			return throwException(
				'The JWT token is missing or does not contain a valid customer reference claim.',
				status,
				_responseText,
				_headers,
				result401,
			);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<TakeUpResponse>(null as any);
	}
}

/** Represents the billing address associated with a payment card. */
export interface BillingAddress {
	/** Gets or sets the postal code (UK postcode). */
	postcode: string;
	/** Gets or sets the first line of the address (house number/name and street). */
	line1: string;
	/** Gets or sets the second line of the address (optional). */
	line2?: string | undefined;
	/** Gets or sets the third line of the address (optional). */
	line3?: string | undefined;
	/** Gets or sets the fourth line of the address (optional). */
	line4?: string | undefined;
	/** Gets or sets the city or town name. */
	city: string;
	/** Gets or sets the county or region (optional). */
	county?: string | undefined;
	/** Gets or sets the ISO 3166-1 alpha-2 country code. */
	country?: string | undefined;
}

/** Command to cancel a pending mileage top-up transaction. */
export interface CancelTopUpMilesCommand {
	/** Gets or sets the policy reference number for the transaction to cancel. */
	policyReference: string;
	/** Gets or sets the MTA transaction ID to cancel. */
	transactionId: string;
}

/** Represents the card vendor/brand. */
export type CardVendor = 'Visa' | 'Mastercard' | 'Other';

/** Represents the cardholder's personal and contact information for payment processing. */
export interface CardholderDetails {
	/** Gets or sets the cardholder's first name. */
	firstName: string;
	/** Gets or sets the cardholder's last name. */
	lastName: string;
	/** Gets or sets the cardholder's phone number. */
	phone: string;
	/** Gets or sets the cardholder's email address. */
	email: string;
	billingAddress: BillingAddress;
}

/** Represents the cover details for an MTA. */
export interface CoverDetails {
	/** Gets or sets the fee amount. */
	fee: number;
	/** Gets or sets the voluntary excess amount. */
	voluntaryExcess: number;
	/** Gets or sets the compulsory excess amount. */
	compulsoryExcess: number;
	/** Gets or sets the list of endorsements. */
	endorsements?: Endorsement[] | undefined;
	/** Gets or sets the list of driver excesses. */
	driverExcesses: DriverExcess[];
}

/** Data transfer object for daily mileage data point. */
export interface DailyMileageDto {
	/** The date of the mileage record. */
	date?: Date;
	/** Total miles driven on this date. */
	miles?: number;
}

/** Represents a driver-specific excess. */
export interface DriverExcess {
	/** Gets or sets the compulsory excess amount for this driver. */
	compulsoryAmount: number;
	/** Gets or sets the data point ID associated with this driver. */
	dataPointId: string;
}

/** Represents an endorsement on the policy. */
export interface Endorsement {
	/** Gets or sets the endorsement name. */
	name?: string | undefined;
	/** Gets or sets the endorsement description/wording. */
	description?: string | undefined;
}

/** Represents an existing card payment method. */
export interface ExistingCardPaymentMethod {
	/** Gets or sets the payment method identifier. */
	id: string;
	/** Gets or sets the last 4 digits of the card number. */
	last4Digits: string;
	vendor: CardVendor;
	/** Gets or sets a value indicating whether this is the default payment method. */
	isDefault: boolean;
}

/** Command to create a payment intent for processing a card payment. */
export interface MakePaymentIntentCommand {
	/** Gets or sets the policy reference number associated with this payment. */
	policyReferenceNumber: string;
	/** Gets or sets the MTA transaction identifier associated with this payment. */
	transactionId: string;
	paymentDetails: PaymentDetails;
	cardholderDetails: CardholderDetails;
}

/** Response from creating a payment intent with the payment service provider. */
export interface MakePaymentIntentResponse {
	/** Gets or sets the unique payment identifier from the payment provider. */
	paymentId?: string | undefined;
	/** Gets or sets the idempotency key used for this payment request. */
	idempotencyKey?: string | undefined;
	/** Gets or sets the client's IP address at the time of the payment request. */
	clientIp?: string | undefined;
}

/** Data transfer object for mileage history response. */
export interface MileageHistoryDto {
	/** The policy reference. */
	policyReference?: string | undefined;
	/** The period type (weekly or monthly). */
	period?: string | undefined;
	/** Start date of the period. */
	startDate?: Date;
	/** End date of the period. */
	endDate?: Date;
	/** Total miles driven during the period. */
	totalMiles?: number;
	/** Daily mileage data points for the period. */
	dataPoints?: DailyMileageDto[] | undefined;
}

/** Data transfer object for mileage summary response. */
export interface MileageSummaryDto {
	/** The policy reference. */
	policyReference?: string | undefined;
	/** The annual mileage allowance from the vehicle record. */
	annualMileageAllowance?: number;
	/** Total miles driven during the current policy term. */
	milesDrivenThisTerm?: number;
	/** Number of days remaining in the policy term. */
	daysRemainingInTerm?: number;
	/** Projected total mileage at term end based on current driving pattern. */
	projectedMileageAtTermEnd?: number | undefined;
	/** Predicted excess miles beyond the annual mileage allowance. */
	predictedExcessMiles?: number | undefined;
	/** Warning flag indicating the customer is projected to exceed their annual mileage allowance. */
	exceedsAllowanceWarning?: boolean;
	/** Flag indicating the predicted excess is within 50% of the annual allowance. */
	isDoublePredictedExcess?: boolean;
	/** Start date of the current policy term. */
	termStartDate?: Date;
	/** End date of the current policy term. */
	termEndDate?: Date;
	/** Date of the most recent trip within the policy term. */
	latestTripDate?: Date | undefined;
}

/** Represents a payment collection option for an MTA. */
export interface MtaPaymentCollectionOption {
	/** Gets or sets the payment option code. */
	code: string;
	/** Gets or sets the unequal instalment amount, if applicable. */
	unequalInstalmentAmount?: number | undefined;
	/** Gets or sets the standard instalment amount, if applicable. */
	standardInstalmentAmount?: number | undefined;
	/** Gets or sets the total amount payable. */
	totalAmountPayable?: number | undefined;
	/** Gets or sets the number of applied instalments. */
	appliedInstalmentCount?: number | undefined;
}

/** Represents the MTA response state. */
export type MtaResponseState = 'Pending' | 'Underwritten' | 'Referred' | 'TakenUp' | 'NotTakenUp' | 'Expired';

/** Represents the payment configuration and amount details for a payment intent. */
export interface PaymentDetails {
	/** Gets or sets a value indicating whether to save the card details for future payments. */
	saveCard: boolean;
	/** Gets or sets the ISO 4217 currency code for the payment. */
	currencyCode: string;
	/** Gets or sets the payment amount in the specified currency. */
	amount: number;
	/** Gets or sets the URL to redirect the client to after the payment is complete. */
	clientReturnUrl?: string | undefined;
}

/** Data transfer object for policy existence check result. */
export interface PolicyExistsDto {
	/** The policy reference that was checked. */
	policyReference?: string | undefined;
	/** Whether the policy exists and belongs to the authenticated customer. */
	exists?: boolean;
}

export interface ProblemDetails {
	type?: string | undefined;
	title?: string | undefined;
	status?: number | undefined;
	detail?: string | undefined;
	instance?: string | undefined;

	[key: string]: any;
}

/** Command to rate a mileage top-up for a policy via the Mid-Term Adjustment (MTA) API. */
export interface RateTopUpMilesCommand {
	/** Gets or sets the policy reference number for the MTA. */
	policyReferenceNumber: string;
	/** Gets or sets the new annual mileage allowance to set on the policy. */
	annualMileage: number;
	/** Gets or sets the optional business mileage component. */
	businessMileage?: number | undefined;
	/** Gets or sets the start date for the mid-term adjustment. */
	mtaStartDate?: Date;
	/** Gets or sets the existing MTA transaction ID, if continuing an existing transaction. */
	transactionId?: string | undefined;
}

/** Response from rating a mileage top-up Mid-Term Adjustment (MTA). */
export interface RateTopUpMilesResponse {
	/** Gets or sets the underwriting option identifier. */
	optionId: string;
	/** Gets or sets the underwriting outcome response identifier. */
	underwritingOutcomeResponseId: string;
	/** Gets or sets the MTA transaction identifier. */
	transactionId: string;
	/** Gets or sets the policy reference number. */
	policyReferenceNumber: string;
	/** Gets or sets the available payment options for the MTA. */
	paymentOptions: MtaPaymentCollectionOption[];
	mtaResponse: MtaResponseState;
	/** Gets or sets a value indicating whether the MTA has been declined. */
	hasDeclined: boolean;
	/** Gets or sets the decline reason if the MTA was declined. */
	declineReason?: string | undefined;
	coverDetails: CoverDetails;
	/** Gets or sets the existing card payment methods available for the policy. */
	existingCardPaymentMethods: ExistingCardPaymentMethod[];
}

/** Command to take up (complete) a mid-term adjustment with payment via Braintree. */
export interface TakeUpCommand {
	/** Gets or sets the policy reference number. */
	policyReference: string;
	/** Gets or sets the MTA transaction ID. */
	transactionId: string;
	takeUpDetails: TakeUpDetails;
	/** Gets or sets the payment ID from the MakePaymentIntent response. */
	paymentId?: string | undefined;
	/** Gets or sets the idempotency key from the MakePaymentIntent response. */
	idempotencyKey?: string | undefined;
	/** Gets or sets the Braintree payment nonce. */
	nonce?: string | undefined;
	/** Gets or sets the Braintree device data for fraud detection. */
	deviceData?: string | undefined;
	/** Gets or sets an existing saved payment method ID. */
	existingCardPaymentMethodId?: string | undefined;
}

/** Represents the details required to take up an MTA option. */
export interface TakeUpDetails {
	/** Gets or sets the payment collection option code identifying the payment plan. */
	paymentCollectionOptionCode: string;
	/** Gets or sets the underwriting option ID to take up. */
	underwritingOptionId: string;
}

/** Response from taking up a mid-term adjustment. */
export interface TakeUpResponse {
	/** Gets or sets the policy reference number. */
	policyReference?: string | undefined;
	/** Gets or sets the transaction ID of the completed MTA. */
	transactionId?: string | undefined;
	/** Gets or sets a value indicating whether the take-up was successful. */
	success?: boolean;
}

export interface ValidationProblemDetails {
	errors?: any | undefined;
	type?: string | undefined;
	title?: string | undefined;
	status?: number | undefined;
	detail?: string | undefined;
	instance?: string | undefined;

	[key: string]: any;
}

export class ApiException extends Error {
	override message: string;
	status: number;
	response: string;
	headers: { [key: string]: any };
	result: any;

	constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
		super();

		this.message = message;
		this.status = status;
		this.response = response;
		this.headers = headers;
		this.result = result;
	}

	protected isApiException = true;

	static isApiException(obj: any): obj is ApiException {
		return obj.isApiException === true;
	}
}

function throwException(
	message: string,
	status: number,
	response: string,
	headers: { [key: string]: any },
	result?: any,
): any {
	if (result !== null && result !== undefined) throw result;
	else throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
	return obj && obj.isAxiosError === true;
}
